import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=47e6681a&scoped=true&"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=47e6681a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6681a",
  null
  
)

export default component.exports